import { Box } from "@mui/material";

export default function AppBackground({ children }) {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#0B1020",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          width: 600,
          height: 600,
          top: -200,
          left: -200,
          background:
            "radial-gradient(circle at center, rgba(178,108,255,0.35), transparent 70%)",
          filter: "blur(120px)",
        }}
      />

      {/* 🔷 Blob bleu */}
      <Box
        sx={{
          position: "absolute",
          width: 500,
          height: 500,
          top: 200,
          right: -150,
          background:
            "radial-gradient(circle at center, rgba(45,226,230,0.25), transparent 70%)",
          filter: "blur(120px)",
        }}
      />

      <Box
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
